import type { ResponseKind } from './arcturianWire';

/**
 * Push-to-talk may interrupt spoken Arcturian output, but never the resolver
 * turn that can still produce a valid action. Keeping this decision pure makes
 * the #886 boundary reviewable instead of burying it in the pointer handler.
 */
export function shouldInterruptVoiceResponse(
  companionMode: string,
  responseKind: ResponseKind | undefined,
): boolean {
  return companionMode === 'arcturian' && responseKind === 'arcturian.primary_audio';
}
